import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {ApiService} from '../services/api.service';
import {HttpClient} from '@angular/common/http';
import {Store} from '../store';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
    env = environment;

    body = document.getElementsByTagName('body')[0];

    constructor(
        private store: Store,
        private http: HttpClient,
        private apiService: ApiService,
    ) { }

    openMenu() {
        this.store.set('menuOpen', true);
    }
    closeMenu() {
        this.store.set('menuOpen', false);
    }
    toggleMenu() {
        let m = this.store.selectForLocal('menuOpen');
        if (m) {
            m = false;
            this.body.classList.remove('body-small', 'mini-navbar');
        } else {
            m = true;
            this.body.classList.add('body-small', 'mini-navbar');
        }
        this.store.set('menuOpen', m);
    }

    all() {
        return this.http.get(this.env.apiPath + 'cms/menus', this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data.data;
        }));
    }

    menuGroups() {
        return this.http.get(this.env.apiPath + 'cms/menugroups', this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data.data;
        }));
    }

    menuGroupMenus(menuGroup) {
        return this.http.get(this.env.apiPath + 'cms/menugroup/' + menuGroup.id, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data.data;
        }));
    }

    saveSortation(menus) {
        const dataToSend = {
            menus
        };
        return this.http.post(this.env.apiPath + 'cms/menus/sort', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    delete(menu) {
        return this.http.delete(this.env.apiPath + 'cms/menus/' + menu.id, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    update(menu) {
        const dataToSend = {
            menu
        };
        return this.http.put(this.env.apiPath + 'cms/menus', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    create(menu) {
        const dataToSend = {
            menu
        };
        return this.http.post(this.env.apiPath + 'cms/menus', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

}
